
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Cookies } from 'react-cookie';
import { useEffect, useRef, useState } from 'react';
import { ReverseFormatDate, OpenBase64Pdf, formatDate, setFocus, GetDate, Number, setTitle } from "../Common/Common";
import Loader from '../Layout/Loader';
import Swal from 'sweetalert2';
import { API_SERVER } from '../../EnvConfig/env_config';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { getCommonData } from '../Common/CommanServices';
import { post } from '../Common/service';
import {  useNavigate } from "react-router-dom";

const RequestSheet = ({ open, setOpen }) => {
    const inputrefs = useRef([]);
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode');
    const SalesPersonName = cookies.get('userName');
    const SalesPersonCode = cookies.get('salesPersonCode')
    const WarehouseCode = cookies.get('warehouseCode');
    const WarehouseName = cookies.get('warehouseName');
    const navigate = useNavigate();
    const [SalesPersonData, setSalesPersonData] = useState([]);
    const [WareHouseData, setWareHouseData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);  
    const [ItemNoData, setItemNoData] = useState([]);
    const [MenuText, setMenuText] = useState("Request Sheet");

    const [AddExtraItem, SetAddExtraItem] = useState({
        ItemNo: "",
        ItemQuantity: 0,
        QuantityInHand: 0
    });

    const [SaveData, setSaveData] = useState({
        SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
        WareHouse: SalesPersonCode ? WarehouseCode + ' : ' + WarehouseName : "",
        RequestSheetDate: GetDate(0),
        ItemDetails: []
    });
    const [Print, setPrint] = useState({
        RequestSheetNo: '',
        IsRequestSheetPrint: false,

    });


    const HandleChange = (prop, value) => {
        setSaveData(SaveData => ({ ...SaveData, [prop]: value }))
        SetAddExtraItem(AddExtraItem => ({ ...AddExtraItem, [prop]: value }))
    }

    useEffect(() => {
        if (SalesPersonCode !== "") {
            getRequestSheetData(SalesPersonCode + ' : ' + SalesPersonName);
        }
        setFocus('txtSalesPerson');
        setTitle('RequestSheet', setOpen);
        setTimeout(() => {
            setMenuText(document.title);
        }, 500);
    }, [])

    const getSalesPerson = () => {
        setSalesPersonData([]);
        let temp = {
            Type: "GetSalesPerson",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token: Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let salesPersonData = res.autoCompleteData || [];
                setSalesPersonData(salesPersonData);
            } else {
                console.error("Error fetching salesperson data:", res.message);
                setSalesPersonData([]);
            }
        });
    };

    const getWareHouse = () => {
        setWareHouseData([])
        let temp = {
            Type: "GetWareHouse",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let warehouseData = res.autoCompleteData || [];
                setWareHouseData(warehouseData);
            } else {
                console.error("Error fetching salesperson data:", res.message);
                setWareHouseData([]);
            }
        });
    }

    const getSlesPersonDetails = (salesPerson) => {
        //setLoading(true)
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token, LoginUserCode: loginCodeString
        }
        post(`${API_SERVER}/api/AutoComplete/GetWarehouseOnSalesperson`, { ...data, salesPerson }, (res) => {
            if (res && res.status) {
                console.log(res)
                if (res.status === "SUCCESS") {
                    setSaveData({
                        ...SaveData,
                        SalesPerson: salesPerson,
                        WareHouse: res.warehouse
                    });
                }
            }
        });
    }

    const getRequestSheetData = async (SalesPerson) => {
        setSaveData({ ...SaveData, SalesPerson: SalesPerson })
        let LoginUserCode = await cookies.get('loginUserCode');
        if (!Token) {
            const cookies = new Cookies();
            cookies.remove('token');
            cookies.remove('loginUserCode');
            cookies.remove('userName');
        } else {
            if (typeof (LoginUserCode) !== 'string') {
                LoginUserCode = String(LoginUserCode);
            }
            // Prepare request data
            const data = {
                SalesPerson: SalesPerson,
                Token: Token,
                LoginUserCode: LoginUserCode
            };

            post(`${API_SERVER}/api/Operation/GetRequestSheetDetails`, { ...data }, (res) => {
                if (res.Status === 'SUCCESS') {
                    let itemDetails = [];
                    res.Data.forEach((item, index) => {
                        let Item = {};
                        Item.Item = item.Item;
                        Item.OrderQuantity = item.OrderQuantity;
                        Item.QuantityInHand = item.QuantityInHand;
                        Item.QuantityRequired = item.QuantityRequired;
                        itemDetails.push(Item);
                    });
                    setSaveData({
                        ...SaveData,
                        SalesPerson: SalesPerson,
                        WareHouse: res.Warehouse,
                        ItemDetails: itemDetails
                    });
                }
                else if (res.message === "EXPIRED") {
                    navigate('/Login')
                }
                if (res.message !== "") {
                    AlertBox("error", res.message, '');
                }
            });
        }
    }

    const handleGetItemDetails = async (ItemNo) => {
        const Token = await cookies.get('token');
        let LoginUserCode = await cookies.get('loginUserCode');
        SetAddExtraItem(
            {
                ...AddExtraItem,
                QuantityInHand: 0,
            })
        setIsLoading(true);

        if (!Token) {
            const cookies = new Cookies();
            cookies.remove('token');
            cookies.remove('loginUserCode');
            cookies.remove('userName');
        } else {
            if (typeof LoginUserCode !== 'string') {
                LoginUserCode = String(LoginUserCode);
            }
            const data = {
                Token: Token, LoginUserCode: LoginUserCode, ItemNo: ItemNo, SalesPerson: SaveData.SalesPerson
            }
            post(`${API_SERVER}/api/Operation/ValidateItemForRequestList`, { ...data }, (res) => {
                if (res.status === 'SUCCESS') {
                    SetAddExtraItem(
                        {
                            ...AddExtraItem,
                            ItemNo: res.item,
                            QuantityInHand: res.quantityInHand,
                        });
                    setFocus('txtQuantity')
                }
                else if (res.message === "EXPIRED") {
                    navigate('/Login')
                }
                else if (res.message !== "") {
                    AlertBox("error", res.message, '');
                }
                setIsLoading(false);
            })
        }
    }

    const handleAddNewItem = () => {
        if (AddExtraItem.ItemNo === "") {
            AlertBox("error", "Please enter item", 'txtItemNo');
        }
        else if (AddExtraItem.ItemQuantity === "" || parseFloat(AddExtraItem.ItemQuantity) <= 0) {
            AlertBox("error", "Quantity should greater than 0", 'txtQuantity');
        }
        else {
            const newItemDetail = {
                Item: AddExtraItem.ItemNo,
                OrderQuantity: 0,
                QuantityInHand: AddExtraItem.QuantityInHand,
                QuantityRequired: AddExtraItem.ItemQuantity
            };
            setSaveData(prevSaveData => ({
                ...prevSaveData,
                ItemDetails: [...prevSaveData.ItemDetails, newItemDetail]
            }));

            SetAddExtraItem({
                ...AddExtraItem,
                ItemNo: '',
                ItemQuantity: 0
            });
        }
    };

    const handleRemoveExtraItemRow = (indexToRemove) => {
        setSaveData(prevSaveData => ({
            ...prevSaveData,
            ItemDetails: prevSaveData.ItemDetails.filter((_, i) => i !== indexToRemove)
        }));
    };

    const getItemNo = () => {
        setItemNoData([])
        let temp = {
            Type: "GetItemNo",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let itemData = res.autoCompleteData || [];
                setItemNoData(itemData);
            } else {
                console.error("Error fetching salesperson data:", res.message);
                setItemNoData([]);
            }
        });
    }

    const handleSaveData = (Type = "") => {
        const Token = cookies.get('token');
        let LoginUserCode = cookies.get('loginUserCode');

        if (!Token) {
            const cookies = new Cookies();
            cookies.remove('token');
            cookies.remove('loginUserCode');
            cookies.remove('userName');
        } else {
            if (typeof LoginUserCode !== 'string') {
                LoginUserCode = String(LoginUserCode);
            }
            setIsLoading(true);
            const data = {
                ...SaveData, Token, LoginUserCode: LoginUserCode, Source: 'WEB', Type,
            }
            post(`${API_SERVER}/api/Operation/SaveRequestSheet`, { ...data }, (res) => {
                if (res.status === 'SUCCESS') {
                    if (res.message !== "") {
                        AlertBox(res.status, res.message, '');
                    }
                    if (res.isRequestSheetPrint) {
                        setPrint({
                            RequestSheetNo: res.requestSheetNo,
                            IsRequestSheetPrint: res.isRequestSheetPrint,
                        });
                        OpenBase64Pdf(res.base64PDF, 'RequestSheetPrint_' + res.requestSheetNo, '_blank');
                    }
                    handleClearData();

                    setIsLoading(false);
                    AlertBox(res.status, res.message, '');
                    handleClearData();
                }
                else if (res.message === "EXPIRED") {
                    navigate('/Login')
                }
                else if (res.message !== "") {
                    AlertBox(res.status, res.message, res.focus);
                }
                if (res.focus !== "") {
                    setFocus(res.focus);
                }
                setIsLoading(false);
            })
        }
    }

    const SaveHandleConfirm = () => {
        Swal.fire({
            title: "Do you want to Generate Request ?",
            showDenyButton: true,
            showCancelButton: false,
            icon: "info",
            confirmButtonText: "Yes",
            denyButtonText: "No"
        }).then((result) => {
            if (result.isConfirmed) {
                handleSaveData('FinalSave')
            }
        });
    }

    const SaveHandleSaveAsDraft = () => {
        handleSaveData("InDraft");
    }

    const handleClearData = () => {
        setSaveData({
            ...SaveData,
            SalesPerson: "",
            WareHouse: "",
            ItemDetails: []
        });
        setFocus('txtSalesPerson')
    }

    let SalesPersonArr = []
    for (let i = 0; i < SalesPersonData.length; i++) {
        let mydata = SalesPersonData[i]?.values
        SalesPersonArr.push(mydata)
    };
    let WareHouseArr = []
    for (let i = 0; i < WareHouseData.length; i++) {
        let mydata = WareHouseData[i]?.values
        WareHouseArr.push(mydata)
    };
    let ItemNoArr = []
    for (let i = 0; i < ItemNoData.length; i++) {
        let mydata = ItemNoData[i]?.values
        ItemNoArr.push(mydata)
    };

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Request No<span className="Required">*</span></label>
                                            <input
                                                type="text"
                                                disabled
                                                className="form-control"
                                                value='System-Generated'
                                            />

                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                inputrefs={inputrefs}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtWareHouse") };
                                                }}
                                                disabled={SalesPersonCode ? true : false}
                                                label='Sales Person'
                                                placeholder="Sales person"
                                                maxLength='50'
                                                options={SalesPersonArr}
                                                id='txtSalesPerson'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => {
                                                    getSalesPerson();
                                                }}
                                                onBlur={() => getSlesPersonDetails(SaveData.SalesPerson)}
                                                inputValue={SaveData.SalesPerson}
                                                onInputChange={(event, newInputValue) => {
                                                    getRequestSheetData(newInputValue);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                inputrefs={inputrefs}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtRequisitionDate") };
                                                }}
                                                label='Ware House'
                                                placeholder="Ware House"
                                                maxLength='50'
                                                options={WareHouseArr}
                                                id='txtWareHouse'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getWareHouse()}
                                                inputValue={SaveData.WareHouse}
                                                onInputChange={(event, newInputValue) => {
                                                    setSaveData({ ...SaveData, WareHouse: newInputValue })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Request Date <span className="Required">*</span></label>
                                            <DatePicker selected={ReverseFormatDate(SaveData.RequestSheetDate)}
                                                id='txtRequisitionDate'
                                                disabled={true}
                                                className="form-control"
                                                placeholderText='Select Request Date'
                                                dateFormat={'dd-MMM-yyyy'}
                                                autoComplete='off'
                                                onChange={(date) => {
                                                    setSaveData({ ...SaveData, RequestSheetDate: formatDate(date) })
                                                }}
                                                maxDate={new Date()}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtItemNo');
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 mt-5">

                                        <div className="recoard-bata service-content-area" style={{ padding: '0rem 0rem 0rem 0rem' }}>
                                            <div className="table-responsive">
                                                <table className="table-bordered" style={{ width: "100%" }} cellSpacing="0">
                                                    <thead className="sticky-top">
                                                        <tr>
                                                            <th>Item<span className="Required">*</span></th>
                                                            <th style={{ textAlign: 'right' }}>Quantity In Hand</th>
                                                            <th style={{ textAlign: 'right' }}>Quantity<span className="Required">*</span></th>
                                                            <th>Add Item</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td className="fields" style={{ width: '60%' }}>
                                                                <AutoCompleteBox
                                                                    inputrefs={inputrefs}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') { setFocus('txtQuantity') };
                                                                    }}
                                                                    label=''
                                                                    style={{ minWidth: '200px' }}
                                                                    placeholder="Item No"
                                                                    maxLength='50'
                                                                    options={ItemNoArr}
                                                                    id='txtItemNo'
                                                                    required={true}
                                                                    ignore_common={true}
                                                                    onFocus={() => getItemNo()}
                                                                    inputValue={AddExtraItem.ItemNo ? AddExtraItem.ItemNo : ''}
                                                                    onInputChange={(event, newInputValue) => {
                                                                        HandleChange('ItemNo', newInputValue)
                                                                    }}
                                                                    onBlur={(e) => handleGetItemDetails(e.target.value)}
                                                                />
                                                            </td>
                                                            <td className='fields' style={{ textAlign: 'right' }}>
                                                                {AddExtraItem.QuantityInHand}
                                                            </td>
                                                            <td className='fields'>
                                                                <input className="form-control" type='text'
                                                                    id={`txtQuantity`}
                                                                    style={{ textAlign: 'right' }}
                                                                    maxLength="10"
                                                                    value={AddExtraItem.ItemQuantity}
                                                                    onChange={(e) => {
                                                                        SetAddExtraItem({ ...AddExtraItem, ItemQuantity: Number(e.target.value) })

                                                                    }}
                                                                    onFocus={(e) => { e.target.select() }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            setFocus('btnAddExtraItem');
                                                                        };
                                                                    }}
                                                                />
                                                            </td>
                                                            <td className='fields'>
                                                                <button
                                                                    title="Add Item"
                                                                    className="btn btn-link text-success btn-sm"
                                                                    id='btnAddExtraItem'
                                                                    onClick={handleAddNewItem}

                                                                >
                                                                    <i className="bi bi-plus"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>

                                                </table>

                                            </div>

                                        </div>
                                    </div>
                                    <>  {
                                        SaveData ? (
                                            <div className="col-lg-12 col-md-12 col-sm-12 mt-5">

                                                <div className="op-invoice recoard-bata service-content-area" style={{ padding: '0rem 0rem 0rem 0rem' }}>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-striped">
                                                            <thead>
                                                                <tr className='light-bg'>
                                                                    <th>Delete</th>
                                                                    <th>Item</th>
                                                                    <th style={{ textAlign: 'right' }}>Order Quantity</th>
                                                                    <th style={{ textAlign: 'right' }}>Quantity Inhand</th>
                                                                    <th style={{ textAlign: 'right' }}>Required Quantity</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {SaveData.ItemDetails?.map((item, bodyIndex) => (
                                                                    <tr className="TableTrhover" key={`row${bodyIndex}`}>
                                                                        <td>
                                                                            <button title="Delete Item" className="btn btn-link text-danger btn-sm" onClick={() => { handleRemoveExtraItemRow(bodyIndex) }}>
                                                                                <i className="bi bi-trash"></i>
                                                                            </button>
                                                                        </td>
                                                                        <td style={{ width: '60%' }}>{item.Item}</td>
                                                                        <td style={{ textAlign: 'right' }}>{item.OrderQuantity}</td>
                                                                        <td style={{ textAlign: 'right' }}>{item.QuantityInHand}</td>
                                                                        <td><input className="form-control" type='text'
                                                                            id={`txtQuantity${bodyIndex}`}
                                                                            style={{ textAlign: 'right' }}
                                                                            maxLength="10"
                                                                            value={item.QuantityRequired}
                                                                            onChange={(e) =>
                                                                                setSaveData(prevSaveData => ({
                                                                                    ...prevSaveData,
                                                                                    ItemDetails: prevSaveData.ItemDetails.map((item, i) => {
                                                                                        if (i === bodyIndex) {
                                                                                            return { ...item, QuantityRequired: e.target.value };
                                                                                        }
                                                                                        return item;
                                                                                    })
                                                                                }))
                                                                            }
                                                                        /> </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div >

                                        ) : (<> </>)
                                    }
                                        {/* Loder start*/}

                                        {/* Loder End*/}
                                    </>
                                    <div className="col-lg-12 mt-4">
                                        <div className="lms-new-button text-center">
                                            <button className="button reset-btn" id='btnSaveAsDraft' onClick={SaveHandleSaveAsDraft}>
                                                <i className="bi bi-check" /> Save As Draft
                                            </button>
                                            <button className="button save-btn" id='btnSave' onClick={SaveHandleConfirm}>
                                                <i className="bi bi-check" /> Save
                                            </button>
                                            {SalesPersonCode ? <></> : <button className="button reset-btn" onClick={handleClearData} >
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
            
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
          
        </main>
    )
}
export default RequestSheet